/*
 * BqGrid.tsx Ergebnis einer BigQuery Abfrage in AGGrid darstellen.
 *
 * Created by Dr. Maximillian Dornseif 2022-02-25 in huWaWi3 25.13.0
 * Copyright (c) 2022 Maximillian Dornseif
 */

import { Panel, PanelType } from '@fluentui/react/lib/Panel'
import { HdErrorBoundary3 } from '@hudora/hd-error-boundary'
import { AgGridFabric, buildColumnDefs } from '@hudora/hd-react-components'
import { usePanel } from 'fluentui-hooks'
import { useMemo } from 'react'
import ReactJson from 'react-json-view'
import { PrismAsyncLight as SyntaxHighlighter } from 'react-syntax-highlighter'
import shStyle from 'react-syntax-highlighter/dist/cjs/styles/prism/prism'

export function BqGrid(props: { title; result }) {
  const [openSqlPanel, sqlPanelProps] = usePanel(`Datenbank Abfrage ${props.title}`)
  const columnDefs = useMemo(() => {
    try {
      return buildColumnDefs(props?.result?.rows)
    } catch (e) {
      console.error(e)
      alert(`Fehler bei der Spaltenerstellung`)
      return []
    }
  }, [props?.result?.rows])

  const panelItem = {
    key: 'sql',
    text: 'SQL',
    title: 'Datenbank Abfrage',
    // This needs an ariaLabel since it's icon-only
    ariaLabel: 'SQL',
    iconOnly: false,
    iconProps: { iconName: 'Database' },
    onClick: openSqlPanel,
  }

  const panel = (
    <Panel {...sqlPanelProps} type={PanelType.medium}>
      <p>
        {'Zugriff unter '}
        <a
          href={`https://console.cloud.google.com/bigquery?project=huwawisql&j=bq:EU:${props?.result?.meta?.jobReference?.jobId}&page=queryresults`}
        >
          {props?.result?.meta?.jobReference?.jobId}
        </a>
        , wenn Sie die entsprechende Google Berechtigung (bigquery.admin) haben.
      </p>
      <SyntaxHighlighter language="sql" style={shStyle}>
        {props?.result?.meta?.configuration?.query?.query}{' '}
      </SyntaxHighlighter>
      <ReactJson src={props.result?.meta} name="Details" collapsed={true} />
    </Panel>
  )

  return (
    <section>
      <h2>{props.title}</h2>
      <HdErrorBoundary3>
        <AgGridFabric commandBarFarItems={[panelItem]} columnDefs={columnDefs} rowData={props.result.rows} />
        {panel}
      </HdErrorBoundary3>
    </section>
  )
}
